module.exports = {
  en: {
    'HRES87UC1': {
      '0': '[HRES87U] Approve Of Resignation',
      '10': '[HRES87U] Approve Of Resignation',
      '20': 'Seq.No.',
      '30': 'Emp. Code',
      '40': 'Name',
      '45': 'Seq No.',
      '50': 'Req. Date',
      '60': 'Effective Date',
      '70': 'Reason of Resignation',
      '80': 'Status',
      '90': 'Approve By',
      '99': 'Approve Of Resignation',
      '100': 'Appr. Date',
      '110': 'Remark',
      '120': 'Next Approve',
      '130': 'Department'
    },
    'HRES87UC2': {
      '0': 'Detail For Approve',
      '10': 'For Emp. Code',
      '20': 'Seq.No.',
      '30': 'Approved by',
      '40': 'Date',
      '50': 'Reference No.',
      '60': 'Record In Blacklist',
      '70': 'Yes',
      '80': 'NO',
      '90': 'Reason of Resign from SSF. Member',
      '100': 'Current Status',
      '110': 'Status',
      '120': 'Approved',
      '130': 'Refused',
      '140': 'Remark'
    },
    'HRES87UC3': {
      '0': 'Detailsof Resign',
      '10': 'Detail of Resign',
      '20': 'Employee Name',
      '30': 'Date Request',
      '40': 'Effective Date',
      '50': 'Reason',
      '60': 'Remark',
      '70': 'List of Company Asset on hold',
      '80': 'Outstanding  Loan',
      '90': 'Unpaid Medical expense',
      '100': 'Details of Scholarship'
    },
    'HRES87UC4': {
      '0': 'Exit Interviews',
      '10': 'Exit Interviews',
      '20': 'For Employee',
      '30': 'Position',
      '40': 'Form no.',
      '50': 'Question',
      '60': 'Details',
      '70': 'Answer'
    },
    'HRES87UC5': {
      '0': 'List of Company Asset On Hold',
      '10': 'List of Company Asset On Hold',
      '20': 'Asset Code',
      '30': 'Description',
      '40': 'Issued Amount',
      '50': 'Unit',
      '60': 'Issued Date'
    },
    'HRES87UC6': {
      '0': 'Details of Outstanding Loan',
      '10': 'Details of Outstanding Loan',
      '20': 'Contract Date',
      '30': 'Contract No.',
      '40': 'Loan Amount',
      '50': 'Outstanding Amount',
      '60': 'Last Payment date',
      '70': 'Type of Loan',
      '80': 'Loan Period (Month)'
    },
    'HRES87UC7': {
      '0': 'Unpaid Med.Expense',
      '10': 'Unpaid Med.Expense',
      '20': 'Emp. Code',
      '30': 'Payment Per Period',
      '40': 'Total Pay Period',
      '50': 'Start Pay Period',
      '60': 'Unpaid Amount',
      '70': 'Total Paid',
      '80': 'Balance',
      '90': 'Last Pay Period'
    },
    'HRES87UC8': {
      '0': 'Details of Scholarship',
      '10': 'Details of Scholarship',
      '20': 'Emp. Code',
      '30': 'Type Of Scholarship',
      '40': 'Commitment Condition',
      '50': 'Start date',
      '60': 'End date'
    }
  },
  th: {
    'HRES87UC1': {
      '0': '[HRES87U] อนุมัติการลาออก',
      '10': '[HRES87U] อนุมัติการลาออก',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '45': 'ลำดับที่',
      '50': 'วันที่ขอ',
      '60': 'วันที่มีผลบังคับใช้',
      '70': 'สาเหตุการพ้นสภาพ',
      '80': 'สถานะ',
      '90': 'ผู้อนุมัติ',
      '99': 'อนุมัติการลาออก',
      '100': 'วันที่อนุมัติ',
      '110': 'หมายเหตุการอนุมัติ',
      '120': 'ผู้อนุมัติลำดับถัดไป',
      '130': 'หน่วยงาน'
    },
    'HRES87UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'ลำดับที่อนุมัติ',
      '30': 'รหัสผู้อนุมัติ',
      '40': 'วันที่',
      '50': 'เลขที่เอกสารอ้างอิง',
      '60': 'บันทึกในบัญชีดำ',
      '70': 'ขึ้นบัญชีดำ',
      '80': 'ไม่ขึ้นบัญชีดำ',
      '90': 'สาเหตุการสิ้นสุดเป็นผู้ประกันตน',
      '100': 'สถานะปัจจุบัน',
      '110': 'สถานะ',
      '120': 'อนุมัติ',
      '130': 'ไม่อนุมัติ',
      '140': 'หมายเหตุ'
    },
    'HRES87UC3': {
      '0': 'รายละเอียดการลาออก',
      '10': 'รายละเอียดการลาออก',
      '20': 'ชื่อพนักงาน',
      '30': 'วันที่บันทึก',
      '40': 'วันที่มีผลบังคับใช้',
      '50': 'สาเหตุการพ้นสภาพ',
      '60': 'หมายเหตุ',
      '70': 'รายชื่อทรัพย์สินที่อยู่ในครอบครอง',
      '80': 'สัญญาเงินกู้ที่อยู่ในระหว่างผ่อนชำระ',
      '90': 'เงินค้างชำระค่ารักษาพยาบาล',
      '100': 'รายละเอียดการรับทุน'
    },
    'HRES87UC4': {
      '0': 'แบบสัมภาษณ์ Exit Interviews',
      '10': 'แบบสัมภาษณ์ Exit Interviews',
      '20': 'สำหรับพนักงาน',
      '30': 'ตำแหน่ง',
      '40': 'รหัสแบบฟอร์มที่ใช้',
      '50': 'คำถาม',
      '60': 'รายละเอียด',
      '70': 'คำตอบ'
    },
    'HRES87UC5': {
      '0': 'รายชื่อทรัพย์สินที่อยู่ในครอบครอง',
      '10': 'รายชื่อทรัพย์สินที่อยู่ในครอบครอง',
      '20': 'รหัสทรัพย์สิน',
      '30': 'รายละเอียด',
      '40': 'จำนวนที่เบิก',
      '50': 'หน่วย',
      '60': 'เบิกวันที่'
    },
    'HRES87UC6': {
      '0': 'สัญญาเงินกู้ที่อยู่ระหว่างผ่อนชำระ',
      '10': 'สัญญาเงินกู้ที่อยู่ระหว่างผ่อนชำระ',
      '20': 'วันที่ทำสัญญา',
      '30': 'เลขที่สัญญา',
      '40': 'วงเงินกู้',
      '50': 'ยอดคงเหลือ',
      '60': 'วันที่ชำระครั้งสุดท้าย',
      '70': 'ประเภทเงินกู้',
      '80': 'ระยะเวลากู้ (เดือน)'
    },
    'HRES87UC7': {
      '0': 'เงินค้างชำระค่ารักษาพยาบาล',
      '10': 'เงินค้างชำระค่ารักษาพยาบาล',
      '20': 'รหัสพนักงาน',
      '30': 'จำนวนเงินชำระต่องวด',
      '40': 'จำนวนงวดที่ชำระ',
      '50': 'งวดที่เริ่มชำระ ง/ด/ป',
      '60': 'ยอดเงินต้น',
      '70': 'จำนวนเงินผ่อนชำระทั้งสิ้น',
      '80': 'คงเหลือ',
      '90': 'งวดสุดท้ายที่จ่าย ง/ด/ป'
    },
    'HRES87UC8': {
      '0': 'รายละเอียดการรับทุน',
      '10': 'รายละเอียดการรับทุน',
      '20': 'รหัสพนักงาน',
      '30': 'ประเภททุน / หลักสูตร',
      '40': 'เงื่อนไขผูกมัด',
      '50': 'วันที่เริ่มต้น',
      '60': 'วันที่สิ้นสุด'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres87u.js